import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "map map--sm"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Marker = _resolveComponent("Marker")!
  const _component_GoogleMap = _resolveComponent("GoogleMap")!

  return (_ctx.location)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_GoogleMap, {
          "api-key": "AIzaSyADSHQOmli9XxoIdFAkvmheBPWiCYrhOxA",
          style: {"width":"100%"},
          "fullscreen-control": false,
          "street-view-control": false,
          "map-type-control": false,
          "scale-control": false,
          "zoom-control": false,
          center: _ctx.location,
          zoom: 12,
          styles: _ctx.googleMapsTheme
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Marker, {
              options: {
          position: _ctx.location,
          icon: {
            scaledSize: { height: 40, width: 40 },
            url: require('@/assets/images/pin-1.svg'),
          },
        }
            }, null, 8, ["options"])
          ]),
          _: 1
        }, 8, ["center", "styles"])
      ]))
    : _createCommentVNode("", true)
}